import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { IJobCandidateInteraction } from 'wisestep-api';
import { WsLocationSearch, WsSelect } from 'wisestep-base';

import { toggleArray } from '../../../../features/candidates/utils/CandidateHelper';
import SmartFilter from '../../../../features/submissionsNew/components/filters/smart/SmartFilter';
import useGetCSRFToken from '../../hooks/useGetCSRFToken';
import { distanceMileOptions } from '../../utils/JobTalentPoolHelper';

interface JobTalentPoolSmartFiltersProps {
  jobTalentPoolQuery: IJobCandidateInteraction;
  updateJobTalentPoolQuery: (updatedQuery: IJobCandidateInteraction) => void;
  handleOnClick: () => void;
}
const JobTalentPoolSmartFilters = ({
  jobTalentPoolQuery,
  updateJobTalentPoolQuery,
  handleOnClick,
}: JobTalentPoolSmartFiltersProps) => {
  const { reset, getValues } = useFormContext();
  const { CSRFToken, authorizationToken } = useGetCSRFToken();
  const clearSmartFilter = (
    filterType: 'locations' | 'radiusInMiles' | 'candidateLocationPref'
  ) => {
    switch (filterType) {
      case 'candidateLocationPref':
        updateJobTalentPoolQuery({
          ...jobTalentPoolQuery,
          searchInCurrentLocation: true,
          searchInPreferredLocation: true,
        });
        reset({ ...getValues(), candidateLocationPref: 'Current or Preferred' });
        break;
      case 'locations':
        updateJobTalentPoolQuery({
          ...jobTalentPoolQuery,
          candidateAllLocationFields: [],
          candidateLocations: [],
        });
        reset({ ...getValues(), locations: [] });
        break;
      case 'radiusInMiles':
        updateJobTalentPoolQuery({ ...jobTalentPoolQuery, radiusInMiles: 0 });
        reset({ ...getValues(), radiusInMiles: 0 });
        break;
    }
  };
  return (
    <Grid>
      <SmartFilter
        filterName={`Location (${getValues('locations')?.length})`}
        filterValue={getValues('locations')?.length ? 'Enable' : ''}
        onClick={handleOnClick}
        onClear={() => clearSmartFilter('locations')}
      >
        <WsLocationSearch
          placeHolder="Search For Locations"
          size="small"
          name="locations"
          multiSelect={true}
          wisestepApi={true}
          hideLabel={true}
          token={CSRFToken}
          authorization={authorizationToken}
        />
      </SmartFilter>
      <SmartFilter
        filterName={`Radius (${getValues('radiusInMiles') > 0 ? 1 : 0})`}
        filterValue={getValues('radiusInMiles') > 0 ? 'Enable' : ''}
        onClick={handleOnClick}
        onClear={() => clearSmartFilter('radiusInMiles')}
      >
        <WsSelect
          name="radiusInMiles"
          selectArray={distanceMileOptions}
          size="small"
          defaultValue="0"
        />
      </SmartFilter>
      <SmartFilter
        filterName="Location Preference (1)"
        filterValue="Enable"
        onClick={handleOnClick}
        onClear={() => clearSmartFilter('candidateLocationPref')}
      >
        <WsSelect
          name="candidateLocationPref"
          selectArray={toggleArray}
          defaultValue="Current or Preferred"
        />
      </SmartFilter>
    </Grid>
  );
};

export default JobTalentPoolSmartFilters;
